export default {
  MANUFACTURER: 'MANUFACTURER',
  HYDROGEN_MANUFACTURER: 'HYDROGEN_MANUFACTURER',
  TRADER: 'TRADER',
  CONSUMER: 'CONSUMER',
  PROVIDER: 'PROVIDER',
  LOADING_OPERATOR: 'LOADING_OPERATOR',
};
